import { Check, ShoppingBag, X } from "lucide-react";
import { useState, useEffect } from "react";
import { useApp } from "../../context/AppContext";
import { useCart } from "../../context/CartContext";

const DISPLAY_MS = 4000;
const EXIT_MS = 300;

export default function Toast() {
  const { toast, clearToast } = useApp();
  const { setCartOpen } = useCart();
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    if (!toast) return;
    setExiting(false);
    const exitTimer = setTimeout(() => setExiting(true), DISPLAY_MS);
    return () => clearTimeout(exitTimer);
  }, [toast]);

  if (!toast) return null;

  const { name, image, sizeName } = toast;

  const dismiss = () => {
    setExiting(true);
    setTimeout(clearToast, EXIT_MS);
  };

  const handleViewCart = () => {
    setCartOpen(true);
    dismiss();
  };

  return (
    <div
      className={`fixed top-20 right-4 z-[200] w-[310px] bg-brand-cream-50
                  rounded-2xl shadow-[0_8px_40px_rgba(0,0,0,0.12)]
                  border border-brand-cream-200 overflow-hidden
                  ${exiting ? "toast-out" : "toast-in"}`}
    >
      {/* Body */}
      <div className="flex items-center gap-3 px-4 pt-4 pb-3">
        {/* Check badge */}
        <div className="w-8 h-8 rounded-full bg-brand-forest-500 flex items-center justify-center shrink-0">
          <Check className="w-4 h-4 text-white" strokeWidth={2.5} />
        </div>

        {/* Thumbnail */}
        {image && (
          <img
            src={image}
            alt={name}
            className="w-11 h-11 rounded-xl object-cover shrink-0 border border-brand-cream-200"
          />
        )}

        {/* Text */}
        <div className="flex-1 min-w-0">
          <p className="font-body text-sm font-semibold text-brand-forest-800 truncate">
            {name}
          </p>
          <p className="font-body text-xs text-brand-forest-400 mt-0.5">
            {sizeName ? `${sizeName} · ` : ""}Added to your bouquet
          </p>
        </div>

        {/* Close */}
        <button
          onClick={dismiss}
          className="p-1 rounded-full text-brand-forest-300 hover:text-brand-forest-600
                     hover:bg-brand-cream-100 transition-colors shrink-0"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>

      {/* Divider */}
      <div className="h-px bg-brand-cream-200 mx-4" />

      {/* Actions */}
      <div className="flex">
        <button
          onClick={handleViewCart}
          className="flex-1 flex items-center justify-center gap-1.5 py-3
                     font-body text-xs font-semibold text-white
                     bg-brand-forest-500 hover:bg-brand-forest-600 transition-colors"
        >
          <ShoppingBag className="w-3.5 h-3.5" />
          View Cart
        </button>
        <div className="w-px bg-brand-cream-200" />
        <button
          onClick={dismiss}
          className="flex-1 py-3 font-body text-xs font-semibold
                     text-brand-forest-500 hover:bg-brand-cream-50 transition-colors"
        >
          Keep Shopping
        </button>
      </div>

      {/* Progress bar */}
      <div className="h-0.5 bg-brand-cream-100">
        <div
          className="h-full bg-brand-crimson-200 origin-left"
          style={{ animation: `toast-progress ${DISPLAY_MS}ms linear forwards` }}
        />
      </div>
    </div>
  );
}
